module.exports = __webpack_public_path__ + "komputronik.png?c07fddccbd24301cb980e7d49c129dad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/komputronik.png
// module id = 968
// module chunks = 2